import { useEffect } from 'react';
import { keycloak } from './app/lib/keycloak';
import { setKeycloakInitStatus, setKeycloakUserInfo, setRoles } from './app/lib/keycloak/slice';
import { useAppDispatch, useAppSelector } from './app/lib/redux/hooks';
import { KeycloakRouter } from './app/lib/router';
import { distinctAirports } from './app/pages/report/slice';
import { Spinner } from './app/ui/molecoles/spinner';

function App() {
  const dispatch = useAppDispatch();
  const keycloakState = useAppSelector((state) => state.keycloak);

  useEffect(() => {
    if (window.location.pathname === "/")
      window.location.replace(window.location.origin + "/report");
  }, [window.location.pathname]);

  keycloak.onAuthSuccess = () => {
    keycloak.loadUserInfo().then((e) => dispatch(setKeycloakUserInfo(e)));
    if (keycloak.hasRealmRole("company")) {
      keycloak.logout({ redirectUri: window.location.origin });
    }
    dispatch(setRoles(keycloak.tokenParsed?.realm_access?.roles));
    dispatch(setKeycloakInitStatus("successfully"));
    dispatch(distinctAirports())
  };

  keycloak.onAuthRefreshError = () => {
    keycloak.logout();
  };

  if (
    keycloakState.keycloakInitStatus === "idle"
  ) {
    return (
      <div className="w-full h-[100vh] flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="App">
      <KeycloakRouter />
    </div>
  );
}

export default App;
